export const BurakProgramSmallIcon = (
  <img
    alt="burak coin"
    src={'https://static.dietly.pl/form/BurakProgramSmallImg.jpg'}
  />
);
